import facebookLogin from '../../../services/facebookLogin/index';
import { fetchData } from '../../../helpers/base_data_fetcher';

export default function bindFacebookLoginButtons() {
  Promise.all([
    fetchData('config.facebook.app_locale'),
    fetchData('site.sub_dir'),
    fetchData('affiliate.id'),
    fetchData('page.loginReturnPath'),
    fetchData('page.flatshare_type'),
  ]).then(
    ([
      facebookAppLocale,
      subDirectory,
      affiliateId,
      loginReturnPath,
      flatshareType,
    ]) => {
      facebookLogin.initialiseApp({ language: facebookAppLocale });
      const userType =
        flatshareType == 'offered' ? 'lookingforashare' : 'haveashare';
      const facebookButtons = document.querySelectorAll(
        '[data-facebook-connect]',
      );
      facebookButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          facebookLogin.login(
            {
              usertype_new: userType,
              // skipping 2nd step would be new for SRP, so needs testing
              // custom_password_required: 0,
              // location: pageData.search.location_id,
              loginfrom_url: loginReturnPath,
              referred_by: affiliateId,
            },
            subDirectory,
          );
        });
      });
    },
  );
}
